<script lang="typescript">
    import { createEventDispatcher } from 'svelte'
    import { fade } from 'svelte/transition'

    export let style: string = ""
    export let backgroundStyle: string = ""
    const dispatch = createEventDispatcher();
</script>

<div class="modal-background" on:click={() => dispatch("wantClose")} transition:fade={{duration: 200}} style={backgroundStyle}></div>
<div class="modal-panel" transition:fade={{duration: 200}} style={style}>
   <slot></slot>
</div>

<style>
    .modal-background {
        background-color: rgba(0,0,0,0.1);
        position: fixed;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
    }

	.modal-panel {
		position: absolute;
		background: var(--panel-background);;
		box-shadow: var(--shadow);
		z-index: 10;
	}
</style>